var render = function render(){var _vm=this,_c=_vm._self._c;return _c('research-graph-block',{attrs:{"graph-title":"述评与综述知识图谱","table-title":"述评与综述三元组表格","chart-data":_vm.chartData,"page-size":10,"node-limit":50}})
}
var staticRenderFns = []

export { render, staticRenderFns }